import React, { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useNavigate } from 'react-router-dom';
import { getToken } from '../../../services/LocalStorageService';
import { useAddUserMutation } from '../../../services/dvagent';
import { Toaster } from '../attributes';

export default function Add() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [alexa, setAlexa] = useState(false);
  const [administrator, setAdministrator] = useState(false);
  const [firstNameError, setFirstNameError] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [addUser] = useAddUserMutation();
  const navigate = useNavigate();
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  const handleFirstName = (event) => {
    setFirstName(event.target.value);
    setFirstNameError('');
  }

  const handleLastName = (event) => {
    setLastName(event.target.value);
    setLastNameError('');
  }

  const handleEmail = (event) => {
    setEmail(event.target.value);
    setEmailError('');
  }

  const handleAdd = async () => {
    setFirstNameError("");
    if (!firstName) {
      setFirstNameError('Please enter first name.');
    }
    if (!lastName) {
      setLastNameError('Please enter last name.');
    }
    if (!email) {
      setEmailError('Please enter email');
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      setEmailError('Invalid email address');
    }
    if (!firstName || !lastName || !email || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      return;
    }
    const actualData = {
      data: {
        "first_name": firstName,
        "last_name": lastName,
        "email": email,
        "profile_picture": "Nan",
        "is_alexa": alexa,
        "is_superuser": administrator
      },
      token: getToken()
    }
    const res = await addUser(actualData);
    if (res.error) {
      if (res.error.status===400) {
        showToast(false, 'ⓘ', 'User already exists');
      } else if (res.error.status===500) {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      } else if (res.error.status==="FETCH_ERROR") {
        showToast(false, 'ⓘ', 'Unable to add user, server error');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      }
    }
    if (res.data) {
      showToast(true, '✔', 'User added');
      setTimeout(() => {
        navigate('/cloud/users', {state:{ dropdownState: 'Users' }});
      }, 5000);
    }
  }

  const handleCancel = () => {
    navigate('/cloud/users', {state:{ dropdownState: 'Users' }});
  }

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };

  return (
    <>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}

      <Grid item xs={12} sm={6} md={3} xl={3}>
        <FormControl sx={{ mb: 1 }} fullWidth size="small">
          <TextField
            label="First Name"
            variant="outlined"
            size="small"
            defaultValue={firstName}
            onChange={handleFirstName}
            helperText={firstNameError}
            error={Boolean(firstNameError)}
            autoComplete="off"
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={3} xl={3}>
        <FormControl sx={{ mb: 1 }} fullWidth size="small">
          <TextField
            label="Last Name"
            variant="outlined"
            size="small"
            defaultValue={lastName}
            onChange={handleLastName}
            helperText={lastNameError}
            error={Boolean(lastNameError)}
            autoComplete="off"
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={12} md={6} xl={6}>
        <FormControl sx={{ mb: 1 }} fullWidth size="small">
          <TextField
            label="Email"
            variant="outlined"
            size="small"
            defaultValue={email}
            onChange={handleEmail}
            helperText={emailError}
            error={Boolean(emailError)}
            autoComplete="off"
          />
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
            control={
            <Switch
                color="primary"
                defaultValue={administrator}
                onChange={(event) => setAdministrator(event.target.checked)}
            />
            }
            label="Administrator privilege"
        />
      </Grid>

      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
          }}
        >
          <FormControl sx={{width: { xs: '100%', sm: '100%', md:'15%', xl:'10%' }}}>
            <Button
              onClick={() => handleAdd()}
                sx={{
                color: '#FFF',
                border: 1,
                borderColor: '#A8A196',
                bgcolor: '#A8A196',
                marginRight:2,
                ":hover": {
                    bgcolor: "#7D7463",
                    borderColor: '#7D7463',
                }
                }}>
              ADD
            </Button>
          </FormControl>
          <FormControl sx={{width: { xs: '100%', sm: '100%', md:'15%', xl:'10%' }}}>
            <Button
              onClick={handleCancel}
              sx={{
                color: '#9BA4B5',
                border: 1,
                borderColor: '#B5C0D0',
                bgcolor: '#FFF',
                ":hover": {
                    bgcolor: "#EEEEEE",
                    borderColor: '#EEEEEE',
                }
              }}
              >
              BACK
            </Button>
          </FormControl>
        </Box>
      </Grid>
    </>
  );
}